import React, { useState } from 'react';

const tasksData = [
  { id: 1, title: 'Complete profile (80%)' },
  { id: 2, title: 'Post a signal or update' },
  { id: 3, title: 'Connect with a new user' },
  { id: 4, title: 'Check market watch section' },
];

export default function DailyTaskChecklist() {
  const [tasks, setTasks] = useState(
    tasksData.map(task => ({ ...task, completed: false }))
  );

  const toggleTask = (id) => {
    setTasks(prev =>
      prev.map(task =>
        task.id === id ? { ...task, completed: !task.completed } : task
      )
    );
  };

  return (
    <div className="bg-black shadow rounded-lg p-4 mb-6">
      <h3 className="text-md font-semibold mb-3">📋 Daily Task Checklist</h3>
      <ul className="space-y-2 text-sm">
        {tasks.map((task) => (
          <li key={task.id} className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={task.completed}
              onChange={() => toggleTask(task.id)}
              className="accent-blue-600"
            />
            <span className={task.completed ? 'line-through text-gray-400' : ''}>
              {task.title}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
